"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _IntroText = require("../IntroText");

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var _FormFieldsBox = _interopRequireDefault(require("../FormFieldsBox"));

var _validators = _interopRequireDefault(require("@jobmatchme/ui/es/utils/validators"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var NumberAndUnitWithOptions = function NumberAndUnitWithOptions(_ref) {
  var config = _ref.config;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);

  var handleChange = function handleChange(event, identifierOrOption) {
    if (event.target.type === 'checkbox') {
      var currentValues = context[config.valueName].value.options;
      var option = identifierOrOption;

      if (currentValues.indexOf(option) >= 0) {
        setValue(config.valueName, {
          identifier: 'options',
          value: currentValues.filter(function (v) {
            return v !== option;
          })
        });
      } else {
        setValue(config.valueName, {
          identifier: 'options',
          value: currentValues.concat(option)
        });
      }
    } else {
      setValue(config.valueName, {
        value: (0, _validators.default)(config.inputType)(event.target.value) ? event.target.value : '',
        identifier: identifierOrOption
      });
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.TranslatedIntroText, {
      config: config
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _styleModule.default.textField,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControl.default, {
        variant: "outlined",
        className: _styleModule.default.firstSelectbox,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
          id: "".concat(config.valueName, "-select1"),
          label: t(config.numberLabel),
          inputProps: {
            min: 1
          },
          type: "number",
          value: context[config.valueName].value.number || config.defaultValue.number,
          onChange: function onChange(e) {
            return handleChange(e, 'number');
          },
          variant: "outlined",
          defaultValue: config.defaultValue.number
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControl.default, {
        variant: "outlined",
        className: _styleModule.default.secondSelectbox,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
          id: "".concat(config.valueName, "-select2"),
          select: true,
          label: t(config.unitLabel),
          value: context[config.valueName].value.unit || config.defaultValue.unit,
          onChange: function onChange(e) {
            return handleChange(e, 'unit');
          },
          variant: "outlined",
          defaultValue: config.defaultValue.unit,
          children: Object.entries(config.unitOptions).map(function (_ref2) {
            var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
                option = _ref3[0],
                translation = _ref3[1];

            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
              value: option,
              children: t(translation)
            });
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _styleModule.default.multipleChoice,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormFieldsBox.default, {
          children: Object.entries(config.additionalOptions).map(function (_ref4) {
            var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
                option = _ref5[0],
                translation = _ref5[1];

            return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: _styleModule.default.row,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
                value: option,
                className: _styleModule.default.formControlLabel,
                labelPlacement: "start",
                control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
                  id: "".concat(config.valueName, "_box_").concat(option),
                  inputProps: {
                    id: "".concat(config.valueName, "_box_").concat(option),
                    'aria-label': 'primary checkbox'
                  },
                  className: _styleModule.default.chkBox,
                  style: {
                    padding: '9px !important;'
                  },
                  checked: context[config.valueName].value.options.indexOf(option) >= 0,
                  onChange: function onChange(e) {
                    return handleChange(e, option);
                  },
                  value: context[config.valueName][config.valueName.deactivation],
                  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBoxOutlineBlank.default, {
                    className: _styleModule.default.sizeIconEmpty
                  }),
                  checkedIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.default, {
                    className: _styleModule.default.sizeIconChecked,
                    color: "primary"
                  })
                }, "".concat(config.valueName, "_box_").concat(option)),
                label: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: _styleModule.default.checkLabel,
                  children: t(translation)
                })
              })
            }, "".concat(config.valueName, "_").concat(option));
          })
        })
      })]
    })]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(NumberAndUnitWithOptions);

exports.default = _default;